var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponenticon = function SvgComponenticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.2 5.664v-.128a.392.392 0 0 0-.176-.328l-6.136-4.2A1.192 1.192 0 0 0 8.216.8h-.432c-.24 0-.474.073-.672.208l-6.136 4.2a.392.392 0 0 0-.176.328v.128c0 .132.066.255.176.328l6.136 4.2c.198.135.432.208.672.208h.432c.24 0 .474-.073.672-.208l6.136-4.2a.392.392 0 0 0 .176-.328Zm-3.28 4.152 1.416-.968 1.688 1.16c.11.073.176.196.176.328v.128a.392.392 0 0 1-.176.328l-6.136 4.2a1.191 1.191 0 0 1-.672.208h-.432c-.24 0-.474-.073-.672-.208l-6.136-4.2a.392.392 0 0 1-.176-.328v-.128c0-.132.066-.255.176-.328l1.688-1.16 1.384.968-.848.584 4.744 3.2h.176l4.68-3.2-.88-.584Z",
    clipRule: "evenodd"
  })));
};
export default SvgComponenticon;